import { encore, resto } from '@saucelabs/sl-util-axios';

export const fetchOptions = () => (
  resto.get('/rest/v1/manual/options')
);
export const fetchMetadata = (page = 'manual') => (
  encore.get(`/api/page_metadata/${page}`)
);
export const putMetadata = (page = 'manual', key, data) => (
  encore.put(`/api/page_metadata/${page}/${key}`, data)
);

export const getJob = (jobId, full = false) => (
  resto.get(`/rest/v1.1/jobs/${jobId}`, {
    params: {
      full,
    },
  })
);

export const getSession = (taskId) => (
  resto.get(`/rest/v1/manual/${taskId}`)
);

export const createSession = (formData) => {
  const payload = {
    url: formData.url,
    tunnel: formData.tunnel || null,
    assets: formData.assets || false,
    ...formData.configuration,
  };

  return resto.post('/rest/v1/tasks', payload);
};

export const removeSession = (taskIds) => (
  resto.delete(
    '/rest/v1/manual',
    {
      data: {
        ids: Array.isArray(taskIds) ? taskIds : [taskIds],
      },
    },
  )
);

export const takeScreenshot = (taskId) => (
  resto.post(`/rest/v1/manual/${taskId}/screenshot`)
);

export const getJobIdBasedOnTaskId = (taskId) => (
  resto.get(`/rest/v1/jobs/${taskId}/task_id`)
);
